import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "d-flex align-items-start" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-chevron-left mr-1" }, null, -1)
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = { class: "ml-auto d-flex align-items-center" }
const _hoisted_6 = {
  key: 1,
  class: "py-5 text-center"
}
const _hoisted_7 = { class: "fs-18 text-gray" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Button = _resolveComponent("Button")
  const _component_SwitchboardItem = _resolveComponent("SwitchboardItem")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_DialogAddEditSwitchboard = _resolveComponent("DialogAddEditSwitchboard")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", null, [
          _createVNode(_component_router_link, {
            to: _ctx.backLink,
            class: "fs-18 text-decoration-none text-gray"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("general.backTo")) + ": " + _toDisplayString(_ctx.currentEntrancePlant.name), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("AppResourceEP.Switchboard")), 1)
        ]),
        _createVNode("div", _hoisted_5, [
          (!_ctx.currentEntrancePlant.syncStatus?.isPlantActive)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                disabled: _ctx.noMoreScsAddresses,
                class: "p-button-rounded p-button-raised p-button--m",
                onClick: _ctx.handleAddSwitchboard
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("AppResourceEP.SwitchboardAddTitle")), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.hasSwitchboards)
      ? (_openBlock(), _createBlock(_component_ElScrollbar, {
          key: 0,
          style: {"margin":"0 -20px -10%","height":"calc(100vh - 240px)"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.switchboards, (switchboard, index) => {
              return (_openBlock(), _createBlock(_component_SwitchboardItem, {
                style: {"margin":"0 20px"},
                class: "mt-3",
                key: index,
                switchboard: switchboard,
                disableOptions: _ctx.currentEntrancePlant.syncStatus?.isPlantActive,
                onDeleteSwitchboard: ($event: any) => (_ctx.handleDeleteSwitchboard(switchboard)),
                onEditSwitchboard: _ctx.handleEditSwitchboard
              }, null, 8, ["switchboard", "disableOptions", "onDeleteSwitchboard", "onEditSwitchboard"]))
            }), 128))
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode("h1", null, _toDisplayString(_ctx.$t("entrancePlant.noSwitchboard")), 1),
          _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("entrancePlant.hintNewSwitchboard")), 1)
        ])),
    _createVNode(_component_DialogAddEditSwitchboard, {
      switchboardToEdit: _ctx.switchboardToEdit,
      isVisible: _ctx.isVisibleAddEditSwitchboard,
      onHideDialog: _ctx.hideAddEditSwitchboard,
      onUpdateList: _ctx.handleUpdateList
    }, null, 8, ["switchboardToEdit", "isVisible", "onHideDialog", "onUpdateList"])
  ], 64))
}